import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  inject,
  InjectFlags,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { UserSkillModel } from '@digilize/shared/definitions/src';
import { forkJoin } from 'rxjs';

import { SkillsService } from '../../../services/skills.service';
import { WizardService } from '../../../services/wizard.service';


interface SkillCategory {
  labelKey: string;
  count: number;
  items: UserSkillModel[];
  expanded: boolean;
  accent: boolean;
}

@Component({
  selector: 'bwc-skills-summary',
  templateUrl: './skills-summary.component.html',
  styleUrls: ['./skills-summary.component.scss'],
})
export class SkillsSummaryComponent implements OnInit {
  @Input() prevBut: boolean;
  @Input() closeBut: boolean;
  @Output() emitClose = new EventEmitter();

  wizardService = inject(WizardService, InjectFlags.Optional);

  dataLoaded = false;
  categories: SkillCategory[] = [];

  constructor(
    private skillsService: SkillsService,
    private elementRef: ElementRef
  ) {}

  ngOnInit(): void {
    forkJoin({
      knowledge: this.skillsService.getKnowledgeSkills(),
      soft: this.skillsService.getSoftSkills(),
      languages: this.skillsService.getLanguageSkills(),
    }).subscribe(({ knowledge, soft, languages }) => {
      this.categories = [
        {
          labelKey: 'global.knowledge_and_skills',
          count: knowledge.data?.length ?? 0,
          items: knowledge.data ?? [],
          expanded: false,
          accent: false,
        },
        {
          labelKey: 'global.soft_skills',
          count: soft.data?.length ?? 0,
          items: soft.data ?? [],
          expanded: false,
          accent: true,
        },
        {
          labelKey: 'global.languages',
          count: languages.data?.length ?? 0,
          items: languages.data ?? [],
          expanded: false,
          accent: false,
        },
      ];
      this.dataLoaded = true;
    });
  }

  toggleCategory(category: SkillCategory): void {
    const wasExpanded = category.expanded;
    this.categories.forEach((cat) => (cat.expanded = false));
    category.expanded = !wasExpanded;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const pillsContainer = this.elementRef.nativeElement.querySelector('.your-skills-card__pills');
    if (pillsContainer && !pillsContainer.contains(event.target)) {
      this.categories.forEach((cat) => (cat.expanded = false));
    }
  }

  goPrev(): void {
    this.wizardService?.goToPrevious();
  }

  close(): void {
    this.emitClose.emit('skills_summary');
  }
}
